import { ThemeVars } from '@storybook/theming';
import { create } from '@storybook/theming/create';

export const buttonwoodTheme: ThemeVars = create({
  base: 'light',
  brandTitle: 'Buttonwood Template Storybook',
  brandUrl: 'https://github.com/buttonwood-protocol/template-client',
  brandImage: './logo-buttonwood.svg',
});
